export default __webpack_public_path__ + "static/media/client21.f25e56ee.png";